module.exports = __webpack_public_path__ + "img/home_2.80a1998a.svg";